import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MenuItem } from '../../../core/models/menu.model';
import { faSave, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-menu-item-form',
  standalone: false,
  templateUrl: './menu-item-form.component.html',
  styleUrl: './menu-item-form.component.scss',
})
export class MenuItemFormComponent {
  faTrash = faTrash;
  faSave = faSave;
  faTimes = faTimes;

  @Input() item: MenuItem = {
    itemName: '',
    itemId: '1',
    itemDescription: '',
    basePrice: null,
    enabled: true,
    variants: [],
    order: 0, // Default order value
  };

  @Output() save = new EventEmitter<MenuItem>();
  @Output() cancel = new EventEmitter<void>();

  /** Add a new variant */
  addVariant() {
    if (!this.item.variants) {
      this.item.variants = []; // Ensure variants array exists
    }
    this.item.variants.push({
      name: '',
      price: null,
      enabled: true,
      default: false,
    });
  }

  /** Remove a variant */
  removeVariant(index: number) {
    this.item.variants?.splice(index, 1);
  }

  /** Set a variant as the default */
  setDefaultVariant(index: number) {
    this.item.variants?.forEach((variant, i) => {
      variant.default = i === index;
    });
  }

  /** Emit the save event */
  submit() {
    this.save.emit(this.item);
  }

  /** Emit the cancel event */
  cancelEdit() {
    this.cancel.emit();
  }
}
